export const TAG_FETCH_REQUEST = 'TAG_FETCH_REQUEST';
export const TAG_FETCH = 'TAG_FETCH';
export const TAG_CREATE_REQUEST = 'TAG_CREATE_REQUEST';
export const TAG_CREATE = 'TAG_CREATE';
export const TAG_UPDATE_REQUEST = 'TAG_UPDATE_REQUEST';
export const TAG_UPDATE = 'TAG_UPDATE';
export const TAG_DELETE_REQUEST = 'TAG_DELETE_REQUEST';
export const TAG_DELETE = 'TAG_DELETE';
export const TAG_CLEAR = 'TAG_CLEAR';
